import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DefaultImageDirective } from './default-image.directive';
import { DefaultImageService } from './default-image.service';
import { ImageModalComponent } from './image-modal/image-modal.component';

const components = [DefaultImageDirective, ImageModalComponent];

@NgModule({
  declarations: components,
  imports: [
    CommonModule
  ],
  exports: components,
  providers: [
    DefaultImageService
  ]
})
export class DefaultImageModule { }
